import { ActionTree } from 'vuex';
import serviceHub from '@/services/hub';

const facebookActions: ActionTree<Store.LiveSocial.State, RootState> = {
  async facebookCreateService({ dispatch }, payload: Services.LiveSocial.Facebook.PostLive) {
    if (payload.page_id) {
      return serviceHub.liveSocial.facebook.postLiveOnPage(payload)
        .then(({ data }) => data)
        .catch((error) => {
          console.log('error', error);
          console.log('error_response', error.response);
          console.log('error_response_data', error.response.data);
          console.log('errorJSON', JSON.parse(error.response.data.error));

          let text = 'general_error_service_operation';

          if (error.response.data.error) {
            const e = JSON.parse(error.response.data.error);

            if (e.code === 100 && e.error_subcode === 33) {
              text = 'manually_removed_service';
            } else if (e.code === 368 && e.error_subcode === 1404078) {
              text = 'suspended_facebook_account';
            } else if (e.code === 190 && e.error_subcode === 460) {
              text = 'suspended_facebook_account';
            }
          }

          dispatch(
            'notification/create', {
              text,
              type: 'error',
            }, { root: true },
          );

          return Promise.reject(error);
        });
    }

    return serviceHub.liveSocial.facebook.postLiveOnFeed(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.log('error', error);
        console.log('error_response', error.response);
        console.log('error_response_data', error.response.data);
        console.log('errorJSON', JSON.parse(error.response.data.error));

        let text = 'general_error_service_operation';

        if (error.response.data.error) {
          const e = JSON.parse(error.response.data.error);

          if (e.code === 100 && e.error_subcode === 33) {
            text = 'manually_removed_service';
          } else if (e.code === 368 && e.error_subcode === 1404078) {
            text = 'suspended_facebook_account';
          } else if (e.code === 190 && e.error_subcode === 460) {
            text = 'suspended_facebook_account';
          }
        }

        dispatch(
          'notification/create', {
            text,
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async facebookDeleteUser(_, payload: Services.LiveSocial.Facebook.DeleteUser) {
    return serviceHub.liveSocial.facebook.deleteUser(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Action - "liveSocial/facebookDeleteUser" ', error);
      });
  },
  async facebookFindLive({ dispatch }, payload: Services.LiveSocial.Facebook.GetLive) {
    if (payload.page_id) {
      return serviceHub.liveSocial.facebook.getLiveOnPage(payload)
        .then(({ data }) => data)
        .catch((error) => {
          console.log('error', error);
          console.log('error_response', error.response);
          console.log('error_response_data', error.response.data);
          console.log('errorJSON', JSON.parse(error.response.data.error));

          let text = 'general_error_service_operation';

          if (error.response.data) {
            const e = JSON.parse(error.response.data.error);
            console.log('errorJSON', e);

            if (e.code === 100 && e.error_subcode === 33) {
              text = 'manually_removed_service';
            } else if (e.code === 368 && e.error_subcode === 1404078) {
              text = 'suspended_facebook_account';
            } else if (e.code === 190 && e.error_subcode === 460) {
              text = 'suspended_facebook_account';
            }
          }

          dispatch(
            'notification/create', {
              text,
              type: 'error',
            }, { root: true },
          );

          return Promise.reject(error);
        });
    }
    return serviceHub.liveSocial.facebook.getLiveOnFeed(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.log('error', error);
        console.log('error_response', error.response);
        console.log('error_response_data', error.response.data);
        console.log('errorJSON', JSON.parse(error.response.data.error));

        let text = 'general_error_service_operation';

        if (error.response.data.error) {
          const e = JSON.parse(error.response.data.error);

          if (e.code === 100 && e.error_subcode === 33) {
            text = 'manually_removed_service';
          } else if (e.code === 368 && e.error_subcode === 1404078) {
            text = 'suspended_facebook_account';
          } else if (e.code === 190 && e.error_subcode === 460) {
            text = 'suspended_facebook_account';
          }
        }

        dispatch(
          'notification/create', {
            text,
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async facebookGetUser({ dispatch }, userId: string) {
    return serviceHub.liveSocial.facebook.getUser(userId)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Action - "liveSocial/facebookGetUser" ', error);

        dispatch(
          'notification/create', {
            text: 'error_fetching_facebook_user',
            type: 'error',
          }, { root: true },
        );

        return Promise.reject();
      });
  },
  async facebookUpdateService({ dispatch }, payload: Services.LiveSocial.Facebook.PutLive) {
    if (payload.page_id) {
      return serviceHub.liveSocial.facebook.putLiveOnPage(payload)
        .then(({ data }) => data)
        .catch((error) => {
          console.log('error', error);
          console.log('error_response', error.response);
          console.log('error_response_data', error.response.data);
          console.log('errorJSON', JSON.parse(error.response.data.error));

          let text = 'general_error_service_operation';

          if (error.response.data.error) {
            const e = JSON.parse(error.response.data.error);

            if (e.code === 100 && e.error_subcode === 33) {
              text = 'manually_removed_service';
            } else if (e.code === 368 && e.error_subcode === 1404078) {
              text = 'suspended_facebook_account';
            } else if (e.code === 190 && e.error_subcode === 460) {
              text = 'suspended_facebook_account';
            }
          }

          dispatch(
            'notification/create', {
              text,
              type: 'error',
            }, { root: true },
          );

          return Promise.reject(error);
        });
    }

    return serviceHub.liveSocial.facebook.putLiveOnFeed(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.log('error', error);
        console.log('error_response', error.response);
        console.log('error_response_data', error.response.data);
        console.log('errorJSON', JSON.parse(error.response.data.error));

        let text = 'general_error_service_operation';

        if (error.response.data.error) {
          const e = JSON.parse(error.response.data.error);

          if (e.code === 100 && e.error_subcode === 33) {
            text = 'manually_removed_service';
          } else if (e.code === 368 && e.error_subcode === 1404078) {
            text = 'suspended_facebook_account';
          } else if (e.code === 190 && e.error_subcode === 460) {
            text = 'suspended_facebook_account';
          }
        }

        dispatch(
          'notification/create', {
            text,
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async facebookCreateStreamTarget(_, payload: Services.LiveSocial.Facebook.CreateWowzaTarget) {
    return serviceHub.liveSocial.facebook.createWowzaTarget(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Action - "liveSocial/facebookCreateStreamTarget" ', error);
      });
  },
  async facebookRemoveStreamTarget(_, payload: Services.LiveSocial.Facebook.RemoveWowzaTarget) {
    return serviceHub.liveSocial.facebook.removeWowzaTarget(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Action - "liveSocial/facebookRemoveStreamTarget" ', error);
      });
  },
  async facebookChangeStreamTarget(_, payload: Services.LiveSocial.Facebook.ChangeWowzaTarget) {
    return serviceHub.liveSocial.facebook.changeWowzaTarget(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Action - "liveSocial/facebookChangeStreamTarget" ', error);
      });
  },
};

export default facebookActions;
